import { install } from 'resize-observer';
import 'intersection-observer';

if (typeof window !== 'undefined' && typeof window.ResizeObserver === 'undefined') {
    install();
}
